import { render, staticRenderFns } from "./HTMLContentRenderer.vue?vue&type=template&id=0036ba20&scoped=true&"
import script from "./HTMLContentRenderer.vue?vue&type=script&lang=ts&"
export * from "./HTMLContentRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./HTMLContentRenderer.vue?vue&type=style&index=0&id=0036ba20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036ba20",
  null
  
)

export default component.exports